import React, { useEffect, useState } from "react";
import {
    Box,
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TextField,
    Typography,
    Chip,
    Card,
    CardContent,
    Stack,
    CircularProgress,
    InputAdornment
} from "@mui/material";
import {
    WorkspacePremium as WorkspacePremiumIcon,
    Save as SaveIcon
} from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";

const getVipBadgeProps = (lvl) => {
    switch (lvl) {
        case 1:
            return { bg: "rgba(180, 83, 9, 0.1)", color: "#b45309", border: "rgba(180, 83, 9, 0.3)" };
        case 2:
            return { bg: "rgba(100, 116, 139, 0.1)", color: "#475569", border: "rgba(100, 116, 139, 0.3)" };
        case 3:
            return { bg: "rgba(234, 179, 8, 0.1)", color: "#ca8a04", border: "rgba(234, 179, 8, 0.3)" };
        case 4:
            return { bg: "rgba(16, 185, 129, 0.1)", color: "#059669", border: "rgba(16, 185, 129, 0.3)" };
        case 5:
            return { bg: "rgba(14, 165, 233, 0.1)", color: "#0284c7", border: "rgba(14, 165, 233, 0.3)" };
        case 6:
            return { bg: "rgba(99, 102, 241, 0.1)", color: "#4f46e5", border: "rgba(99, 102, 241, 0.3)" };
        case 7:
            return { bg: "rgba(168, 85, 247, 0.1)", color: "#9333ea", border: "rgba(168, 85, 247, 0.3)" };
        case 8:
            return { bg: "rgba(236, 72, 153, 0.1)", color: "#db2777", border: "rgba(236, 72, 153, 0.3)" };
        case 9:
            return { bg: "rgba(239, 68, 68, 0.1)", color: "#dc2626", border: "rgba(239, 68, 68, 0.3)" };
        case 10:
            return { bg: "rgba(245, 158, 11, 0.15)", color: "#d97706", border: "rgba(245, 158, 11, 0.4)" };
        default:
            return { bg: "rgba(100, 116, 139, 0.1)", color: "#475569", border: "rgba(100, 116, 139, 0.3)" };
    }
};

const formatNumberWithCommas = (val) => {
    if (val === null || val === undefined || val === "") return "";
    const numStr = String(val).replace(/[^0-9]/g, "");
    if (!numStr) return "";
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const parseFormattedNumber = (val) => {
    if (!val && val !== 0) return 0;
    const cleanStr = String(val).replace(/[^0-9]/g, "");
    return cleanStr ? Number(cleanStr) : 0;
};

const getReadableCurrencyText = (num) => {
    if (!num || isNaN(num) || num <= 0) return "";
    if (num >= 1000000000) {
        const ty = num / 1000000000;
        return `${Number(ty.toFixed(3))} Tỷ điểm`;
    }
    if (num >= 1000000) {
        const trieu = num / 1000000;
        return `${Number(trieu.toFixed(3))} Triệu điểm`;
    }
    if (num >= 1000) {
        const nghin = num / 1000;
        return `${Number(nghin.toFixed(3))} K điểm`;
    }
    return `${num} điểm`;
};

function SettingProfit() {
    const [vipData, setVipData] = useState({});
    const [loading, setLoading] = useState(true);
    const [savingVip, setSavingVip] = useState(false);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const fetchVipSetting = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/profit/get`)
            .then((res) => {
                if (res.data?.data?.[0]) {
                    setVipData(res.data.data[0]);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        fetchVipSetting();
    }, []);

    const handleSaveVip = (e) => {
        if (e) e.preventDefault();
        setSavingVip(true);
        const formData = {
            id: vipData._id,
            nap1: Number(vipData.nap1 || 0),
            nap2: Number(vipData.nap2 || 0),
            nap3: Number(vipData.nap3 || 0),
            nap4: Number(vipData.nap4 || 0),
            nap5: Number(vipData.nap5 || 0),
            nap6: Number(vipData.nap6 || 0),
            nap7: Number(vipData.nap7 || 0),
            nap8: Number(vipData.nap8 || 0),
            nap9: Number(vipData.nap9 || 0),
            nap10: Number(vipData.nap10 || 0),
            v1: Number(vipData.v1 || 0),
            v2: Number(vipData.v2 || 0),
            v3: Number(vipData.v3 || 0),
            v4: Number(vipData.v4 || 0),
            v5: Number(vipData.v5 || 0),
            v6: Number(vipData.v6 || 0),
            v7: Number(vipData.v7 || 0),
            v8: Number(vipData.v8 || 0),
            v9: Number(vipData.v9 || 0),
            v10: Number(vipData.v10 || 0),
            top1: Number(vipData.top1 || 0),
            top2: Number(vipData.top2 || 0),
            top3: Number(vipData.top3 || 0),
            top4: Number(vipData.top4 || 0),
            top5: Number(vipData.top5 || 0),
            top6: Number(vipData.top6 || 0),
            top7: Number(vipData.top7 || 0),
            top8: Number(vipData.top8 || 0),
            top9: Number(vipData.top9 || 0),
            top10: Number(vipData.top10 || 0)
        };

        axios
            .put(`${process.env.REACT_APP_API_URL}/profit/update`, formData)
            .then(() => {
                setSavingVip(false);
                swal(t("success"), "Cập nhật cấu hình VIP thành công!", "success");
                fetchVipSetting();
            })
            .catch(() => {
                setSavingVip(false);
                swal("Lỗi", "Không thể lưu cấu hình VIP", "error");
            });
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 4, px: 3, bgcolor: "#f8fafc", minHeight: "100vh" }}>
                    <Container maxWidth={false}>
                        {/* Header */}
                        <Box sx={{ mb: 4 }}>
                            <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", fontSize: { xs: "22px", md: "26px" } }}>
                                Cài Đặt Hệ Thống VIP
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#64748b", mt: 0.5 }}>
                                Quản lý thông số các cấp độ VIP 1 tới VIP 10, mức nạp tích lũy và các mức thưởng đặc quyền.
                            </Typography>
                        </Box>

                        {/* Card Form */}
                        <Card
                            sx={{
                                borderRadius: "14px",
                                border: "1px solid #e2e8f0",
                                boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.05)",
                                bgcolor: "#ffffff"
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} spacing={2} mb={3}>
                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                        <WorkspacePremiumIcon sx={{ color: "#d97706", fontSize: 30 }} />
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "18px", color: "#0f172a" }}>
                                                Bảng Cấu Hình Cấp Độ VIP (VIP 1 - VIP 10)
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: "#64748b", fontSize: "13px" }}>
                                                Thiết lập mức nạp tích lũy thăng cấp, thưởng lên cấp và thưởng sinh nhật thành viên.
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    <Button
                                        variant="contained"
                                        startIcon={savingVip ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />}
                                        onClick={handleSaveVip}
                                        disabled={savingVip}
                                        sx={{
                                            background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                                            color: "#ffffff",
                                            borderRadius: "8px",
                                            px: 3,
                                            py: 1,
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            textTransform: "none",
                                            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)"
                                        }}
                                    >
                                        {savingVip ? "Đang lưu..." : "Lưu cấu hình VIP"}
                                    </Button>
                                </Stack>

                                <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e2e8f0", borderRadius: "10px", overflow: "hidden" }}>
                                    <Table sx={{ width: "100%" }}>
                                        <TableHead sx={{ bgcolor: "#f8fafc" }}>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "15%" }}>Cấp VIP</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "28%" }}>Mức Nạp Tích Lũy (điểm)</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "28%" }}>Thưởng Thăng Cấp (điểm)</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#334155", py: 1.5, width: "29%" }}>Quà Sinh Nhật VIP (điểm)</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loading ? (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center" sx={{ py: 6 }}>
                                                        <CircularProgress size={32} color="primary" />
                                                        <Typography variant="body2" sx={{ mt: 1, color: "#64748b" }}>Đang tải dữ liệu VIP...</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((lvl) => {
                                                    const napKey = `nap${lvl}`;
                                                    const topKey = `top${lvl}`;
                                                    const vKey = `v${lvl}`;
                                                    const badge = getVipBadgeProps(lvl);

                                                    return (
                                                        <TableRow key={lvl} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                            <TableCell sx={{ py: 1.5 }}>
                                                                <Chip
                                                                    label={`VIP ${lvl}`}
                                                                    size="small"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        bgcolor: badge.bg,
                                                                        color: badge.color,
                                                                        border: `1px solid ${badge.border}`,
                                                                        height: 28,
                                                                        px: 1.5
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ py: 1.5 }}>
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    type="text"
                                                                    value={formatNumberWithCommas(vipData[napKey])}
                                                                    onChange={(e) => setVipData({ ...vipData, [napKey]: parseFormattedNumber(e.target.value) })}
                                                                    placeholder={`Mức nạp VIP ${lvl}`}
                                                                    helperText={getReadableCurrencyText(vipData[napKey])}
                                                                    FormHelperTextProps={{ sx: { color: "#2563eb", fontWeight: 600, fontSize: "11px", mt: 0.3 } }}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start">điểm</InputAdornment>
                                                                    }}
                                                                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ py: 1.5 }}>
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    type="text"
                                                                    value={formatNumberWithCommas(vipData[topKey])}
                                                                    onChange={(e) => setVipData({ ...vipData, [topKey]: parseFormattedNumber(e.target.value) })}
                                                                    placeholder={`Thưởng lên VIP ${lvl}`}
                                                                    helperText={getReadableCurrencyText(vipData[topKey])}
                                                                    FormHelperTextProps={{ sx: { color: "#059669", fontWeight: 600, fontSize: "11px", mt: 0.3 } }}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start">điểm</InputAdornment>
                                                                    }}
                                                                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ py: 1.5 }}>
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    type="text"
                                                                    value={formatNumberWithCommas(vipData[vKey])}
                                                                    onChange={(e) => setVipData({ ...vipData, [vKey]: parseFormattedNumber(e.target.value) })}
                                                                    placeholder={`Quà SN VIP ${lvl}`}
                                                                    helperText={getReadableCurrencyText(vipData[vKey])}
                                                                    FormHelperTextProps={{ sx: { color: "#d97706", fontWeight: 600, fontSize: "11px", mt: 0.3 } }}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start">điểm</InputAdornment>
                                                                    }}
                                                                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleSaveVip}
                                        disabled={savingVip}
                                        sx={{
                                            background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                                            color: "#ffffff",
                                            borderRadius: "8px",
                                            px: 4,
                                            py: 1.2,
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            textTransform: "none",
                                            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)"
                                        }}
                                    >
                                        {savingVip ? "Đang lưu..." : "Lưu cấu hình VIP"}
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SettingProfit;

